import { getFirestore, collection, getDocs } from "firebase/firestore";

function levenshteinDistance(str1, str2) {
  const len1 = str1.length;
  const len2 = str2.length;
  const matrix = [];
  for (let i = 0; i <= len2; i++) matrix[i] = [i];
  for (let j = 0; j <= len1; j++) matrix[0][j] = j;
  for (let i = 1; i <= len2; i++) {
    for (let j = 1; j <= len1; j++) {
      if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  return matrix[len2][len1];
}

function isNameSimilar(name1, name2) {
  if (!name1 || !name2) return false;
  const n1 = String(name1).toLowerCase().trim();
  const n2 = String(name2).toLowerCase().trim();
  if (n1 === n2) return true;
  if (n1.includes(n2) || n2.includes(n1)) return true;
  const distance = levenshteinDistance(n1, n2);
  const maxDistance = n1.length < 5 ? 2 : 3;
  return distance <= maxDistance;
}

/**
 * Search for existing wrestlers that may be duplicates (same school, weight, similar name).
 * @param {{ firstName: string, lastName: string, school: string, rankWeightClass: string }} params
 * @returns {Promise<Array<{ id: string, ...data }>>} potential duplicates
 */
export async function searchForDuplicateWrestlers(params) {
  const { firstName, lastName, school, rankWeightClass } = params || {};
  try {
    const db = getFirestore();
    const snapshot = await getDocs(collection(db, "athletes"));
    const duplicates = [];
    const schoolStr = school != null ? String(school).trim() : "";
    const weightStr =
      rankWeightClass != null ? String(rankWeightClass).trim() : "";
    snapshot.forEach((doc) => {
      const athlete = { id: doc.id, ...doc.data() };
      const athleteSchool =
        athlete.School != null ? String(athlete.School).trim() : "";
      const athleteWeight =
        athlete.RankWeightClass != null
          ? String(athlete.RankWeightClass).trim()
          : "";
      const schoolMatch = schoolStr === athleteSchool;
      const weightMatch = weightStr === athleteWeight;
      if (schoolMatch && weightMatch) {
        if (
          isNameSimilar(firstName, athlete.FirstName) &&
          isNameSimilar(lastName, athlete.LastName)
        ) {
          duplicates.push(athlete);
        }
      }
    });
    return duplicates;
  } catch (_) {
    return [];
  }
}

export { isNameSimilar, levenshteinDistance };
